import { LifecyclePhase, type LifecycleHook } from '@tundr/lifecycle-hooks';
import { useBreadcrumbStore } from './store/breadcrumb.store';

export const breadcrumbResetOp: LifecycleHook = {
  name: 'breadcrumb:reset',
  fn: () => useBreadcrumbStore().reset(),
  phases: [
    { phase: LifecyclePhase.APP_LAUNCH },
    { phase: LifecyclePhase.LOGOUT },
  ],
};
